import { render, staticRenderFns } from "./SmBadgeRead.vue?vue&type=template&id=b6ac647a&scoped=true&"
import script from "./SmBadgeRead.vue?vue&type=script&lang=ts&"
export * from "./SmBadgeRead.vue?vue&type=script&lang=ts&"
import style0 from "./SmBadgeRead.vue?vue&type=style&index=0&id=b6ac647a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ac647a",
  null
  
)

export default component.exports